import Stickyfill from 'stickyfilljs'

export default function StickyPolyfill () {
  const STICKY_ELEMENTS = document.querySelectorAll('.sticky')
  Stickyfill.add(STICKY_ELEMENTS)
}
